<app-menu *ngIf="authService.isAuthenticated()"></app-menu>
<router-outlet></router-outlet>
<app-update-modal *ngIf="showUpdateModal" (onRefresh)="onRefresh()" (onLater)="onLater()"></app-update-modal>
